module.exports = __webpack_public_path__ + "img/logo.7daaa3a5.png";